import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './badges.styl'

export default class Badges extends Component {
  static propTypes = {
    items: PropTypes.array,
    item: PropTypes.object
  }
  static defaultProps = {}

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { items, item } = this.props
    let template = null

    if (items) {
      template = items.map((badge, index) => {
        const isActive = !badge.active ? styles.disabled : ''

        return (
          <span
            key={index}
            className={`${styles.badge} ${styles[`badge-${index + 1}`]} ${isActive}`}
          >
            {badge.label}
          </span>
        )
      })
    }

    if (item) {
      template = <span>{item.label}</span>
    }

    return (
      <div>
        {template}
      </div>
    )
  }
}
